import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { subscribeNotificationInsert } from "@/lib/notificationsBus";

/**
 * Tracks unread `bid_won` notifications for the current user.
 * Toast + chime are owned by useGlobalNotificationAlerts.
 */
export function useUnreadWins(userId: string | null | undefined) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) { setCount(0); return; }
    let cancelled = false;

    const fetchCount = async () => {
      const { count: c } = await supabase
        .from("notifications")
        .select("id", { count: "exact", head: true })
        .eq("recipient_user_id", userId)
        .eq("type", "bid_won")
        .eq("is_read", false);
      if (!cancelled) setCount(c ?? 0);
    };
    fetchCount();

    const off = subscribeNotificationInsert(userId, (row) => {
      if ((row as { type?: string })?.type !== "bid_won") return;
      setCount((c) => c + 1);
    });

    return () => { cancelled = true; off(); };
  }, [userId]);

  return count;
}
